import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { HiPlay, HiLightningBolt, HiAcademicCap, HiChartBar } from 'react-icons/hi';
import Navbar from '../components/Navbar';

const ProceedToTest = () => {
  const navigate = useNavigate();
  const [isStarting, setIsStarting] = useState(false);

  const handleProceed = () => {
    setIsStarting(true);
    setTimeout(() => {
      navigate('/progress', { state: { currentLevel: 1, completedLevels: [] } });
    }, 300);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 via-indigo-50 to-purple-100">
      <Navbar />

      <div className="flex items-center justify-center" style={{ minHeight: 'calc(100vh - 64px)' }}>
        <div className="max-w-2xl w-full px-4 py-6">

          {/* Main Card */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="bg-white rounded-3xl shadow-2xl p-6 md:p-8 text-center"
          >
            {/* Icon */}
            <motion.div
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ delay: 0.2, type: 'spring', damping: 14 }}
              className="mb-4 flex justify-center"
            >
              <div className="w-20 h-20 bg-purple-600 rounded-full flex items-center justify-center shadow-lg">
                <HiAcademicCap className="text-white text-4xl" />
              </div>
            </motion.div>

            {/* Title */}
            <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-2">
              Ready to Begin?
            </h1>

            {/* Description */}
            <p className="text-base text-gray-600 mb-6">
              Start your adaptive AI assessment journey and progress from
              <span className="font-semibold text-purple-600"> Novice </span>
              to
              <span className="font-semibold text-purple-600"> Guru</span>.
            </p>

            {/* Features */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mb-6">
              <div className="bg-purple-50 rounded-xl p-3">
                <HiLightningBolt className="text-purple-600 text-2xl mx-auto mb-1" />
                <div className="font-semibold text-gray-800 text-sm">Adaptive</div>
                <div className="text-xs text-gray-600">Matches your level</div>
              </div>

              <div className="bg-purple-50 rounded-xl p-3">
                <HiChartBar className="text-purple-600 text-2xl mx-auto mb-1" />
                <div className="font-semibold text-gray-800 text-sm">Progressive</div>
                <div className="text-xs text-gray-600">7 core levels</div>
              </div>

              <div className="bg-purple-50 rounded-xl p-3">
                <HiAcademicCap className="text-purple-600 text-2xl mx-auto mb-1" />
                <div className="font-semibold text-gray-800 text-sm">Educational</div>
                <div className="text-xs text-gray-600">Learn as you go</div>
              </div>
            </div>

            {/* CTA Button */}
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={handleProceed}
              disabled={isStarting}
              className="inline-flex items-center gap-3 px-8 py-4 bg-purple-600 hover:bg-purple-700 text-white text-lg font-bold rounded-2xl shadow-lg transition-all disabled:opacity-50"
            >
              <HiPlay className="text-xl" />
              <span>{isStarting ? 'Starting...' : 'Proceed to Test'}</span>
            </motion.button>

            {/* Info */}
            <p className="mt-4 text-xs text-gray-500">
              ⏱️ 5 questions per level · 🎯 Pass 3 to advance
            </p>

            {/* Tips (INSIDE SAME SECTION) */}
            <div className="mt-6 text-left bg-purple-50 rounded-xl p-4">
              <h3 className="font-semibold text-gray-800 mb-2">💡 Tips for Success</h3>
              <ul className="text-sm text-gray-600 space-y-1">
                <li>• Read questions carefully</li>
                <li>• Don’t rush — think clearly</li>
                <li>• Each level builds on the last</li>
                <li>• Retake anytime to improve</li>
              </ul>
            </div>
          </motion.div>

        </div>
      </div>
    </div>
  );
};

export default ProceedToTest;